import React, { Component } from 'react'

const MessageTemplate={
        OTPSentMessage:'OTP sent successfully',
        ErrorMessage:'Oops! An error occured, please try again.',
        LinkSentMessage:'eBook Download Link has been successfully sent.',
        InvaliOTPMessage:'Please Enter Valid OTP',
        MaximumLimitMessage:'Maximum otp limit reached, please try again after sometime.',
        redirectUrl:'https://www.featsystems.com/',
        API_BASE_URL:'https://patapi.featsystems.com/api',
        //API_BASE_URL:'http://localhost:8385/api'
}

export default MessageTemplate;

